import { render, staticRenderFns } from "./ExternalUserForm.vue?vue&type=template&id=ebf47120&scoped=true&"
import script from "./ExternalUserForm.vue?vue&type=script&lang=js&"
export * from "./ExternalUserForm.vue?vue&type=script&lang=js&"
import style0 from "./ExternalUserForm.vue?vue&type=style&index=0&id=ebf47120&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf47120",
  null
  
)

export default component.exports